module.exports = __webpack_public_path__ + "media/nightlife.7504a348.mp4";